export default __webpack_public_path__ + "static/media/volkihar-banner.36dd2855.jpg";